import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  /**
   * @author Frank Edward Daza González
   * @version 2018-11-06
   * @param next 
   * @param state 
   */
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const userRole: string = this.authService.getRol();

    if (this.authService.isAuthenticate() && userRole === next.data.role) {
      return true;
    } else {
      this.router.navigate(['/sign-in']);
      return false;
    }
  }

}
